import React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { EditOrderAction, useEditOrderSvc } from '../service'

import { useForm } from 'react-hook-form'
import moment from 'moment'

export function EditOrderTime(props: { onClose: () => void; onSave: (action: EditOrderAction) => void }): JSX.Element {
  const editOrderSvc = useEditOrderSvc()

  console.log('Order Date time', editOrderSvc.getOrderTime())

  const form = useForm({
    mode: 'onBlur',
    defaultValues: { value: moment(editOrderSvc.getOrderTime()).format('YYYY-MM-DDTHH:mm') },
  })

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = form

  const validateAndSave = (data: any) => {
    console.log('Data', moment(data.value).toISOString())
    props.onSave({
      op: 'update-order_time',
      value: moment(data.value).toISOString(),
      label: moment(data.value).format('LLL'),
      prev_value: editOrderSvc.getOrderTime(),
      prev_label: moment(editOrderSvc.getOrderTime()).format('LLL'),
    })
    props.onClose()
  }

  return (
    <Modal isOpen={true} onClosed={props.onClose}>
      <ModalHeader>
        <span>Change Order Time</span>
      </ModalHeader>
      <form className="form-horizontal" onSubmit={handleSubmit(validateAndSave)}>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="value">Order Time: ({moment(editOrderSvc.getOrderTime()).format('LLL')})</label>
            <input
              id="value"
              className="form-control input input-small"
              style={errors && errors.value ? { color: 'red' } : {}}
              type="datetime-local"
              {...register('value', {
                required: 'is required',
                valueAsDate: true,
              })}
            />
            {errors && errors.value && <span className="text-danger">{errors.value.message}</span>}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">
            Save
          </Button>
          <Button color="secondary" onClick={props.onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  )
}
